<div *ngIf="step===1">
    <div mat-dialog-title class="title text-lg">
        Giỏ hàng
    </div>
    <mat-dialog-content>
        <div class="pt-5 ">
            <div class="form-control">
                <div class="flex ">
                    <label for="" class="whitespace-nowrap me-5 ">Tài khoản</label>
                    <mat-form-field class=" ms-4 text-base" appearance="outline">
                        <input class="text-base" matInput [ngModel]="data" disabled>
                    </mat-form-field>
                </div>
            </div>
            <div>
                <div class="flex">
                    <label for="" class="whitespace-nowrap min-w-[30%]">Danh sách sản phẩm</label>
                </div>
                <div class="ps-5 ms-5 m-3">
                    <div *ngFor="let item of cart?.items; let index = index">
                        <ng-container>
                            <div
                                class="grid grid-cols-3 2xl:grid-cols-7 xl:grid-cols-7 lg:grid-cols-7 md:grid-cols-4 sm:grid-cols-3 gap-2 form-control-fill n15">
                                <ng-container>
                                    <mat-form-field appearance="fill" class="text-base ms-5 col-span-2">
                                        <mat-label class="text-lg">Tên sản phẩm </mat-label>
                                        <input matInput style="color: black;" [ngModel]="item.product.name" disabled>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill" class="text-base ms-5">
                                        <mat-label class=" text-lg">Giá</mat-label>
                                        <input matInput style="color: black;" [ngModel]="item.product.price" disabled>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill" class="text-base ms-5 text-base">
                                        <mat-label class=" text-lg">Số lon</mat-label>
                                        <input matInput style="color: black;" [ngModel]="item.product.quantity"
                                            disabled>
                                    </mat-form-field>
                                </ng-container>
                                <mat-form-field appearance="fill" class="ms-5 text-base">
                                    <mat-label class=" text-lg">Số lượng</mat-label>
                                    <input matInput style="color: black;" type="number" min="0"
                                        [(ngModel)]="item.quantity" [disabled]="!isEdit[index]" #quantity="ngModel"
                                        required (ngModelChange)="setQuantity($event, index)">
                                    <div class="invalid-feedback ms-3" *ngIf="checkValidators(item.quantity)">
                                        {{checkValidators(item.quantity)}}
                                    </div>
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="ms-5 text-base">
                                    <mat-label class=" text-lg">Tổng</mat-label>
                                    <input matInput style="color: black;" [ngModel]="item.cost" disabled>
                                </mat-form-field>
                                <div>
                                    <button [hidden]="isEdit[index]" class="m-1 text-base whitespace-nowrap"
                                        mat-stroked-button (click)="onEditItem(index)">
                                        <mat-icon>edit</mat-icon>
                                        Sửa
                                    </button>
                                    <button [hidden]="!isEdit[index]" class="m-1 text-base whitespace-nowrap"
                                        mat-stroked-button (click)="onSaveItem(item,index)">
                                        <mat-icon>edit</mat-icon>
                                        Lưu
                                    </button>
                                    <button class="m-1 text-base whitespace-nowrap" mat-stroked-button
                                        (click)="onDeleteItem(item)">
                                        <mat-icon>delete</mat-icon>
                                        Xóa
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="actions w-full">
        <button class="text-base whitespace-nowrap" mat-button cdkFocusInitial (click)="nextStep()">
            Thanh toán
        </button>
        <button class="text-base whitespace-nowrap" routerLink="/user/n13" mat-button mat-dialog-close>
            Tiếp tục mua sắm
        </button>
    </mat-dialog-actions>
</div>

<div *ngIf="step===2">
    <div mat-dialog-title class="title text-lg">
        Thông tin chuyển khoản
    </div>
    <mat-dialog-content>
        <div class="my-4" style="margin-top: 1rem;">
            <label for="" class="whitespace-nowrap">
                Nội dung chuyển khoản: {{cart?.orderCode}}
            </label>
        </div>
        <div class="grid grid-cols-2 gap-4 text-slate-950">
            <div>
                <div class="my-3 text-xl">Số tiền cần thanh toán</div>
                <div>
                    <div class="form-control">
                        <div class="flex ">
                            <label for="" class="whitespace-nowrap min-w-[40%] mx-2">Tổng tiền</label>
                            <mat-form-field class="formcontrol-sm w-full text-base" appearance="outline">
                                <input matInput [ngModel]="cart.totalPrice |currency:'VND':''" disabled>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-control">
                        <div class="flex ">
                            <label for="" class="whitespace-nowrap min-w-[40%] mx-2">Doanh số tích lũy</label>
                            <mat-form-field class="formcontrol-sm w-full text-base" appearance="outline">
                                <input matInput [ngModel]="cart.totalCommissionPrice |currency:'VND':''" disabled>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-control">
                        <div class="flex ">
                            <label for="" class="whitespace-nowrap min-w-[40%] mx-2">Thanh toán:</label>
                            <mat-form-field class="formcontrol-sm w-full text-base" appearance="outline">
                                <input matInput [ngModel]="cart.totalPrice |currency:'VND':''" disabled>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="my-3 text-xl">Thông tin hóa đơn</div>
                <form [formGroup]="formInfo">
                    <div class="form-control">
                        <div class="flex ">
                            <label for="" class="whitespace-nowrap min-w-[40%] mx-2">Số điện thoại</label>
                            <mat-form-field class="w-full text-base" appearance="outline">
                                <input matInput formControlName="phone" inputmode="numeric" min="0">
                                <mat-error class="text-base p-0 h-4"
                                    *ngIf="formInfo.get('phone').invalid">{{getErrorMessage(formInfo.get('phone'))}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-control">
                        <div class="flex ">
                            <label for="" class="whitespace-nowrap min-w-[40%] mx-2">Địa chỉ giao hàng</label>
                            <mat-form-field class=" text-base" appearance="outline">
                                <input matInput formControlName="address">
                                <mat-error class="text-base"
                                    *ngIf="formInfo.get('address').invalid">{{getErrorMessage(formInfo.get('address'))}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
                <div class="flex w-full">
                    <label for="" class="whitespace-nowrap min-w-[40%] mx-2">Chọn ảnh xác nhận:</label>
                    <div class="form-control-image">
                        <mat-form-field style="width: 100%;" class=" text-base">
                            <button class="text-base whitespace-nowrap" mat-icon-button matPrefix
                                (click)="f_input.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <input type="text text-base" readonly matInput [formControl]="fileName"
                                placeholder="Hóa đơn thanh toán" />
                            <input type="file" accept="image/gif, image/jpeg, image/jpg, image/png" multiple hidden
                                #f_input (change)="handleFileInputChange(f_input.files)" />
                            <mat-error class="text-base" *ngIf="fileName.invalid">Chọn một file</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="urlImg" class="flex justify-center mb-4">
            <img [src]="urlImg" alt="" class="min-w-[15rem] max-w-[15rem] min-h-[13rem] max-h-[13rem]">
        </div>
        <div style="overflow-x: auto;">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 demo-table">
                <ng-container *ngFor="let column of columnsToData;" [matColumnDef]="column.columnDef">
                    <th mat-header-cell *matHeaderCellDef>
                        {{column.header}}
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{column.cell(row)}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end" class="actions w-full">
        <button class="text-base whitespace-nowrap" mat-button cdkFocusInitial (click)="onSubmit()">
            Xác nhận
        </button>
        <button class="text-base whitespace-nowrap" mat-button (click)="onBack()">Quay lại</button>
    </mat-dialog-actions>
</div>